// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-export/download.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/export/src/download.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo malla-vpn-app
//     node fleet/fleet.ts check --repo malla-vpn-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Browser delivery for {@link ExportDelivery}. Requires a DOM, so it is only
 * ever selected on a target with the `window` capability.
 *
 * The pure serializers (`datasetToCsv`, `datasetToHtml`) stay DOM-free in their
 * own modules so they remain trivially unit-testable.
 */
import type { ExportDelivery } from "./delivery";

/** Triggers a file download for arbitrary text content via a Blob + anchor. */
export function downloadTextFile(filename: string, content: string, mimeType: string): void {
  const blob = new Blob([content], { type: `${mimeType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener noreferrer";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // Revoke after the click has consumed the URL.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Opens the print-ready HTML in a new window and triggers the print dialog
 * ("Save as PDF"). Falls back to downloading the HTML when the popup is
 * blocked — which is also what happens in a headless test.
 */
function printHtmlInNewWindow(filename: string, html: string): void {
  const win = window.open("", "_blank");
  if (!win) {
    downloadTextFile(filename, html, "text/html");
    return;
  }
  win.document.open();
  win.document.write(html);
  win.document.close();
  // Give the new document a tick to lay out before invoking print.
  win.addEventListener("load", () => {
    win.focus();
    win.print();
  });
}

export const browserDelivery: ExportDelivery = {
  kind: "browser",
  saveText(filename, content, mimeType) {
    downloadTextFile(filename, content, mimeType);
    return Promise.resolve();
  },
  deliverPrintable(filename, html) {
    printHtmlInNewWindow(filename, html);
    return Promise.resolve();
  },
};
